import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1599e190")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Tree = _resolveComponent("Tree")

  return (_openBlock(), _createBlock(_component_Tree, {
    id: "folders-tree",
    value: _ctx.nodes,
    onNodeExpand: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setOpenFolderIcon($event))),
    onNodeCollapse: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setClosedFolderIcon($event)))
  }, {
    default: _withId((slotProps) => [
      _createVNode(_component_Checkbox, {
        name: "folders",
        disabled: slotProps.node.parentId == null,
        modelValue: _ctx.selectedFolders,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedFolders = $event)),
        value: slotProps.node.id,
        onChange: _ctx.emitSelectedFolders
      }, null, 8, ["disabled", "modelValue", "value", "onChange"]),
      _createVNode("b", null, _toDisplayString(slotProps.node.label), 1)
    ]),
    _: 1
  }, 8, ["value"]))
})